import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from "@mui/material";

const NetlistDialog = ({ open, onClose, netlistData, netlistText, onCopy, isDarkMode }) => {
  const bg = isDarkMode ? "#1e1e1e" : "#f5f5f5";
  const fg = isDarkMode ? "#d4d4d4" : "#212121";
  const sectionHeaderColor = isDarkMode ? "#7ec8e3" : "#1565c0";
  const dividerColor = isDarkMode ? "#444" : "#ccc";

  const preStyle = {
    fontFamily: "monospace",
    fontSize: "12px",
    whiteSpace: "pre",
    overflowX: "auto",
    backgroundColor: bg,
    color: fg,
    borderRadius: 1,
    p: 1.5,
    m: 0,
    minHeight: 80,
  };

 
  if (!netlistData || typeof netlistData !== "object") {
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontSize: "14px", pb: 1 }}>Netlist</DialogTitle>
        <DialogContent>
          <Box component="pre" sx={preStyle}>
            {netlistText || ""}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} size="small" variant="outlined">Close</Button>
          <Button onClick={onCopy} size="small" variant="contained">Copy</Button>
        </DialogActions>
      </Dialog>
    );
  }

  const { spice, symbolNetlists = [] } = netlistData;
  const hasSymbols = symbolNetlists.length > 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontSize: "14px", pb: 1 }}>Netlist</DialogTitle>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          overflowY: "auto",
          maxHeight: "70vh",
        }}
      >
        {/* ── Symbol subckts ──────────────────────────────────────────── */}
        {hasSymbols &&
          symbolNetlists.map(({ symbolName, spice: symbolSpice }) => (
            <Box key={symbolName}>
              <Typography
                variant="caption"
                sx={{
                  color: sectionHeaderColor,
                  fontWeight: 700,
                  fontFamily: "monospace",
                  letterSpacing: 0.5,
                  display: "block",
                  mb: 0.5,
                }}
              >
                ── Symbol: {symbolName}
              </Typography>
              <Box
                component="pre"
                sx={{
                  ...preStyle,
                  borderLeft: `3px solid ${sectionHeaderColor}`,
                  pl: 1.5,
                }}
              >
                {symbolSpice}
              </Box>
            </Box>
          ))}

        {hasSymbols && (
          <Box
            sx={{
              borderTop: `1px solid ${dividerColor}`,
              mt: -1,
            }}
          />
        )}

        {/* ── Top-level netlist ────────────────────────────────────────── */}
        <Box>
          {hasSymbols && (
            <Typography
              variant="caption"
              sx={{
                color: sectionHeaderColor,
                fontWeight: 700,
                fontFamily: "monospace",
                letterSpacing: 0.5,
                display: "block",
                mb: 0.5,
              }}
            >
              ── Top Level
            </Typography>
          )}
          <Box component="pre" sx={preStyle}>
            {netlistData.spice}
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} size="small" variant="outlined">
          Close
        </Button>
        <Button onClick={onCopy} size="small" variant="contained">
          Copy
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NetlistDialog;